(() => {
  function setupNavigation() {
    document.querySelectorAll('.bcp-nav .bcp-nav-dropdown').forEach(menu => {
      if (menu.dataset.hoverReady) return;
      menu.dataset.hoverReady = 'true';
      let timer;
      menu.addEventListener('pointerenter', event => {
        if (event.pointerType !== 'mouse') return;
        clearTimeout(timer);
        document.querySelectorAll('.bcp-nav-dropdown[open]').forEach(other => { if (other !== menu) other.open = false; });
        menu.open = true;
      });
      menu.addEventListener('pointerleave', event => {
        if (event.pointerType === 'mouse') timer = setTimeout(() => { if (!menu.contains(document.activeElement)) menu.open = false; }, 160);
      });
      menu.addEventListener('focusout', () => setTimeout(() => { if (!menu.contains(document.activeElement) && !menu.matches(':hover')) menu.open = false; }, 0));
    });
  }
  setupNavigation();
  document.addEventListener('shopify:section:load', setupNavigation);
})();
